import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { walletBlocklistService } from "@services/apis/WalletBlocklist";
import React, { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddWalletBlocklistSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddWalletBlocklistSlider: React.FC<AddWalletBlocklistSliderProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [address, setAddress] = useState("");
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const resetForm = () => {
    setAddress("");
    setReason("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    if (!address.trim()) {
      handleError({ message: "Wallet address is required" });
      return;
    }

    try {
      setIsLoading(true);
      const response = await walletBlocklistService.addWallet({
        address: address.trim(),
        reason: reason.trim() || undefined,
      });
      handleSuccess({
        message:
          response.msg || "Wallet address added to blocklist successfully",
      });
      resetForm();
      onSuccess?.();
      onClose();
    } catch (error: any) {
      handleError({
        message:
          error?.response?.data?.msg ||
          "Failed to add wallet. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading="Add Wallet"
      onClose={handleClose}
      onClickCross={handleClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px] gap-4">
        <GlobalTextInputField
          placeholder="Enter wallet address"
          value={address}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAddress(e.target.value)
          }
          title="Wallet Address"
        />
        <GlobalTextInputField
          placeholder="Optional reason or note"
          value={reason}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setReason(e.target.value)
          }
          title="Reason (Optional)"
        />
        <CustomButton
          text="ADD WALLET"
          onClick={handleSubmit}
          isActive={!!address.trim()}
          isButtonLoading={isLoading}
        />
      </div>
    </SlidingPanel>
  );
};

export default AddWalletBlocklistSlider;
